import * as S from './styles';

export interface DetailGroup {
  name: string;
  rows: { label: string; value: string }[];
}

interface Props {
  groups: DetailGroup[];
}

export default function DetailList({ groups }: Props) {
  return (
    <S.Groups>
      {groups.map((group) => (
        <section key={group.name} aria-label={group.name}>
          <S.GroupName>{group.name}</S.GroupName>
          <S.Rows>
            {group.rows.map((row) => (
              <S.Row key={row.label}>
                <S.Label>{row.label}</S.Label>
                <S.Value>{row.value}</S.Value>
              </S.Row>
            ))}
          </S.Rows>
        </section>
      ))}
    </S.Groups>
  );
}
